module.exports = __webpack_public_path__ + "img/open-in-new.755b43da.svg";